<template lang="pug">
v-card.elevation-1
  .d-flex
    .flex-1
      v-card-title.pa-2.pl-4.font-size-16
        span.font-weight-700 Tickets
        span.font-weight-700.primary--text  &nbsp;cerrados&nbsp;
        span.font-weight-700  {{tipo && tipo.toLowerCase()}} (Duración en dias y horas)
      v-card-subtitle.pb-3.font-size-12.grey--text Listado general de tickets cerrados ordenados por duracion
    v-btn.ma-2( color="info"  small  @click="$refs.lineChart.fetchTicketsCerrados()")
      v-icon sync
      | Actualizar
    //- v-menu(transition='slide-x-transition' bottom='' right='')
    //-   template(v-slot:activator='{ on, attrs }')
    //-     v-btn.ma-3.animated.fadeInUp.faster(icon   v-bind='attrs' v-on='on' )
    //-       v-icon  more_vert
    //-   v-list(dense)
    //-     v-list-item(@click="$refs.lineChart.fetchTicketsCerrados()")
    //-       v-list-item-title
    //-         | Refrescar datos del grafico
  v-divider
  .d-flex.mx-1(v-if="count")
    .flex-1.ma-2
      v-card.pa-2.text-xs-center.elevation-1(height="100%")
        .d-flex.ai-center.jc-center.fd-column
          .display-1.font-weight-700 {{cantidadTicketsCerrados}}
          span.font-size-12 Total de tickets
  //- .d-flex.mx-4.py-3
  //-   .d-flex
  //-     v-select(v-model='tipo' solo :items="tiempos" :disabled="isLoading"   label='Tiempo'  dense hide-details @change="fetchTicketsPorAnio()")
      //- .d-flex
      //-   .mr-4
      //-     v-text-field(label='Desde' v-model="desde" solo dense type="date"  hide-details )
      //-   .div
      //-     v-text-field(label='Hasta' v-model="hasta" solo dense type="date" hide-details)
  line-chart(
    v-if="renderChart"
    :tipo="tipo"
    ref="lineChart"
    @count="obtenerCantidad",
    :desde="desde"
    :hasta="hasta"
  )
</template>
<script>
import moment from 'moment'
// import { apiGet, notify } from '../util/general'
import LineChart from './c_chart_line_tickets_cerrados_por_horas_activo'
export default {
  name: 'c_card_chart_line_tickets_cerrados_por_horas_activo',
  components : {
    LineChart
  },
  props: {
    tipo : {
      type   : String,
      default: 'garantia'
    },
    count : {
      type   : Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading              : false,
      renderChart            : true,
      serieRecall            : '',
      incluirCerrados        : false,
      ticketsCerrados        : [],
      cantidadTicketsCerrados: 0,
      numeroRecnum           : 0,
      noMore                 : false,
      disabledScrollExcecute : false,
      // desde                  : '',
      // hasta                  : ''
      desde                  : moment().subtract(30, 'days').format('YYYY-MM-DD'),
      hasta                  : moment().format('YYYY-MM-DD'),
      tiempos : [
        {
          name : 'dd'
        }
      ]
    }
  },
  methods : {
    obtenerCantidad (count) {
      var vm = this
      vm.cantidadTicketsCerrados = count
    },
    reRenderChart () {
      var vm = this
      vm.renderChart = false
      vm.$nextTick(() => {
        vm.renderChart = true
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// c_card_chart_line_tickets_cerrados_por_horas_activo.vue?0d227cc4